import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function EditLocationButton(props: { path: string }) {
  const { t } = useTranslation()

  return <Link to={props.path}>{t('locations.edit')}</Link>
}
